"use client";

import { Session, User } from "@supabase/supabase-js";
import { useEffect, useState } from "react";

import { Database } from "@punchup/data/supabase.types";
import { createClientComponentClient } from "@punchup/data/supabase/client";
import { getSession } from "../../supabase/supabase";

/**
 * useUser Usage:
 * Gets the current user from Supabase and returns it.
 *
 * @returns
 * - undefined if the user is still loading
 * - null if the user is not logged in
 * - a Supabase User object if the user is logged in
 */
export default function useUser() {
  const [user, setUser] = useState<User | null | undefined>(undefined);
  const supabase = createClientComponentClient<Database>();

  useEffect(() => {
    // retrieve the session and initialize the state
    getSession(supabase).then((session: Session | null) => {
      setUser(session?.user ?? null);
    });

    // subscribe to auth state changes
    const { data } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === "SIGNED_OUT") {
        setUser(null);
      } else if (session) {
        setUser(session.user);
      }
    });

    // call unsubscribe to remove the event listener
    return () => data.subscription.unsubscribe();
  }, [supabase]);

  return user;
}
